"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapIsInvalidToProps = exports.withIsInvalid = exports.BroadcastIsInvalid = void 0;

var withChannel_1 = require("../decorators/withChannel");

var helpers = withChannel_1.createChannel('isInvalid');
var Broadcast = helpers.Broadcast;
exports.BroadcastIsInvalid = Broadcast;
var withChannel = helpers.withChannel;
exports.withIsInvalid = withChannel;

function mapIsInvalidToProps(isInvalid) {
  return {
    invalid: isInvalid
  };
}

exports.mapIsInvalidToProps = mapIsInvalidToProps;